import { useCallback } from 'react';
import { useAuth } from '../contexts/TestAuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export type ActivityAction = 
  | 'view' 
  | 'edit' 
  | 'share' 
  | 'download' 
  | 'generate' 
  | 'delete' 
  | 'duplicate' 
  | 'comment'
  | 'calculate'
  | 'export'
  | 'invite'
  | 'add_member'
  | 'remove_member'
  | 'update_role';

interface LogActivityOptions {
  reportId?: string;  // Optional for non-report activities
  actionType: ActivityAction;
  actionDetails?: string;
  section?: string;
  metadata?: Record<string, any>;
}

export function useActivityLog() {
  const { getToken } = useAuth();

  const logActivity = useCallback(async (options: LogActivityOptions) => {
    try {
      const token = await getToken();
      if (!token) return;

      await axios.post(
        `${BACKEND_URL}/api/v1/activity/log`,
        {
          report_id: options.reportId || 'system',  // Use 'system' for non-report activities
          action_type: options.actionType,
          action_details: options.actionDetails,
          section: options.section,
          metadata: options.metadata || {}
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
    } catch (error) {
      // Silently fail - activity logging shouldn't break the app
      console.warn('Failed to log activity:', error);
    }
  }, [getToken]);

  return { logActivity };
}

export default useActivityLog;
